import React, { useEffect } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./SignSummary.scss";
import { meBeam } from '../../../../../../assets/beams/meBeam';
import { useBeam } from '@randajan/bifrost/client/react';
import { Locale } from '../../../../../../assets/Locale';
import { sayEventAvModes } from '../../../../eventSay';

export const SignSummary = (props)=>{
    const { event, onSubmit, onDone } = props;
    const say = Locale.use();
    // const { data:me } = useBeam(meBeam);

    useEffect(_=>{
        if (!event) { onDone(); }
    }, [event, onDone]);

    if (!event) { return null; }

    const { gameSpace, locale, avMode, startAtEst } = event;
    // const { alias } = me;
    
    return (
        <Block className="SignSummary" caption="SignSummary">
            <p>Adresa: {gameSpace?.address}</p>
            {avMode.length && <p>Režim(y) záznamu: {sayEventAvModes(say, avMode)}</p>}
            <p>Datum začátku: {startAtEst}</p>
            <p>Jazyk eventu: {locale}</p>
            {/* {
                alias ? <p>Tvůj alias je: {alias}</p> : <p>Nemáš vyplněný alias, ve hře budeš identifikován číslem.</p>
            }
            <p>Svůj alias a další údaje můžeš kdykoliv změnit ve svém profilu</p> */}
        </Block>
    )
}

